import { render, staticRenderFns } from "./LimpezaManual.vue?vue&type=template&id=f19106d0&"
import script from "./LimpezaManual.vue?vue&type=script&lang=js&"
export * from "./LimpezaManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports